import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-result-card-wrapper disbursement" }
const _hoisted_2 = { class: "search-result-card-section-group left" }
const _hoisted_3 = { class: "group" }
const _hoisted_4 = {
  class: "search-result-card-section",
  id: "borrowername"
}
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  class: "search-result-card-section",
  id: "status"
}
const _hoisted_7 = { class: "xcertificationstatus" }
const _hoisted_8 = { class: "group" }
const _hoisted_9 = {
  class: "search-result-card-section referenceid",
  id: "referenceid"
}
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  class: "search-result-card-section",
  id: "amount"
}
const _hoisted_12 = {
  class: "search-result-card-section lender",
  id: "lender"
}
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "group disbursement-details" }
const _hoisted_15 = {
  class: "search-result-card-section disbursementDate",
  id: "disbursementDate"
}
const _hoisted_16 = { class: "icon icon-calendar-checkmark" }
const _hoisted_17 = {
  class: "search-result-card-section disbursementMethod",
  id: "disbursementMethod"
}
const _hoisted_18 = { class: "icon icon-bank-arrow-right" }
const _hoisted_19 = {
  key: 0,
  class: "search-result-card-section",
  id: "createdatutc"
}
const _hoisted_20 = { style: {"color":"red"} }

import { PropType } from "vue";
import useFunctions from "@/use/functions1";
import { useDebugDateKey } from "@/composables/useDebugDateKey";


export default /*@__PURE__*/_defineComponent({
  __name: 'DisbursementResultCard',
  props: {
  disbursement: {
    type: Object as PropType<any>,
    required: true,
  },
},
  setup(__props) {

const { decodeHTMLEncodedStr } = useFunctions();
const { showCreatedDate } = useDebugDateKey();

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "borrower-name",
            title: _unref(decodeHTMLEncodedStr)(__props.disbursement.borrowerFullName)
          }, _toDisplayString(_unref(decodeHTMLEncodedStr)(__props.disbursement.borrowerFullName) || "No Name"), 9, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(__props.disbursement.disbursementStatusTypeName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h5", {
            class: "icon icon-single-person",
            title: __props.disbursement.referenceId
          }, _toDisplayString(__props.disbursement.referenceId), 9, _hoisted_10)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(__props.disbursement.disbursementAmountFormatted), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("h5", {
          class: "icon icon-hand-shake",
          title: __props.disbursement.lenderName
        }, _toDisplayString(__props.disbursement.lenderName), 9, _hoisted_13)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h5", _hoisted_16, _toDisplayString(__props.disbursement.disbursementDateDisplay), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h5", _hoisted_18, _toDisplayString(__props.disbursement.disbursementMethodTypeDescription), 1)
        ])
      ]),
      (_unref(showCreatedDate))
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(__props.disbursement.createdAtUtc), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})